import axios from 'axios';

/**
 * Драйвер для отслеживания за онлайном сущностей
 */
export default class OnlineDriver {
  constructor(backendEndpoint) {
    this.trackingHash = {};
    this.backendEndpoint = backendEndpoint;
  }

  async fetchStats() {
    const idList = Object.keys(this.trackingHash);

    if (!idList.length) {
      return null;
    }

    try {
      const res = await axios.post(this.backendEndpoint, {
        id_list: idList,
      });

      return res.data;
    } catch (e) {
      console.error(e);
    }

    return null;
  }

  track(id) {
    if (!this.trackingHash[id]) {
      this.trackingHash[id] = 1;

      return;
    }

    this.trackingHash[id] += 1;
  }

  unTrack(id) {
    this.trackingHash[id] -= 1;

    if (this.trackingHash[id] <= 0) {
      delete (this.trackingHash[id]);
    }
  }
}
